import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import { Formik, Form, Field } from 'formik';
import { bindActionCreators } from 'redux';
import { domainActions } from '../../../../store/domainStore';
import { isNullOrUndefined, validateInput } from '../../../../store/storeFunctions';
import { propertySkSearchBy } from '../../../../store/searchStore';
import { number as YupNumber, string as YupString, object as YupObject } from '../../../common/Yup';
import BbInput from '../../../styling/bbInput';
import SelectOption from '../../../searchSections/selectOption';
import PropertySkFormButtons from './propertySkFormButtons';
import PropertySkSearchParamsErrorMessage from './propertySkSearchParamsErrorMessage';
import PropertySkSelectCadastreUnitForm, { keys as selectKeys, excludedKeys } from './propertySkSelectCadastreUnitForm';

const keys = {
    ...selectKeys,
    register: "register",
    parcelNo1: "parcelNo1",
    parcelNo2: "parcelNo2",
    parcelNo3: "parcelNo3"
};

class PropertySkParcelSearchForm extends React.Component {
    render() {
        return (
            <Formik
                ref={(el) => this.formRef = el}
                enableReinitialize={true}
                validationSchema={this.createValidationSchema()}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                    [keys.regionId]: "",
                    [keys.districtId]: "",
                    [keys.municipalityId]: "",
                    [keys.cadastreUnitId]: "",
                    [keys.register]: "",
                    [keys.parcelNo1]: "",
                    [keys.parcelNo2]: "",
                    [keys.parcelNo3]: "",
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                    const query = [
                        `searchBy=${propertySkSearchBy.landId}`,
                        ...Object.keys(values).filter(f => !excludedKeys.includes(f) && values[f] !== "").map(k => `${k}=${values[k]}`)
                    ]
                    this.props.history.push(`/search/property-sk/results${(query.length > 0 ? "?" + query.join("&") : "")}`);
                }}>
                {({ values, setFieldValue, errors }) => (
                    <Form>
                        {Object.keys(errors).length > 0 && <div className="column">
                            <PropertySkSearchParamsErrorMessage
                                errors={Object.keys(errors).map(k => k.replace("Id", "").replace(/parcelNo./, "parcelNumber")).filter((v, i, a) => a.indexOf(v) === i)}
                            />
                        </div>}
                        <PropertySkSelectCadastreUnitForm
                            regionId={values[keys.regionId]}
                            districtId={values[keys.districtId]}
                            municipalityId={values[keys.municipalityId]}
                            cadastreUnitId={values[keys.cadastreUnitId]}
                            setFieldValue={setFieldValue}
                        />
                        <div>
                            <BbInput type="select-noformik" label={this.props.translate("PropertySk.Search.Register")} placeholder={{ type: "column" }}
                                options={this.getParcelRegistries()}
                                formatOptionLabel={SelectOption}
                                value={this.getParcelRegistries().find(f => f.value === values[keys.register])}
                                onChange={(e) => setFieldValue(keys.register, e.value)}
                                disabled={isNullOrUndefined(values[keys.cadastreUnitId]) || values[keys.cadastreUnitId] === ""}
                                isDisabled={isNullOrUndefined(values[keys.cadastreUnitId]) || values[keys.cadastreUnitId] === ""}
                            />
                        </div>
                        <div>
                            <BbInput type="custom" label={this.props.translate("PropertySk.Search.ParcelNumber")} placeholder={{ type: "column" }}
                                custom={
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <Field type="text" className="input" name={keys.parcelNo1} style={{ display: "block", width: "50%" }}
                                            disabled={isNullOrUndefined(values[keys.cadastreUnitId]) || values[keys.cadastreUnitId] === ""} onInput={(e) => validateInput(e)}/>
                                        <div>&nbsp;/&nbsp;</div>
                                        <Field type="text" className="input" name={keys.parcelNo2} style={{ display: "block", width: "25%" }}
                                            disabled={isNullOrUndefined(values[keys.cadastreUnitId]) || values[keys.cadastreUnitId] === ""} onInput={(e) => validateInput(e)}/>
                                        <div>&nbsp;/&nbsp;</div>
                                        <Field type="text" className="input" name={keys.parcelNo3} style={{ display: "block", width: "25%" }}
                                            disabled={isNullOrUndefined(values[keys.cadastreUnitId]) || values[keys.cadastreUnitId] === ""} onInput={(e) => validateInput(e)}/>
                                    </div>
                                }
                            />
                        </div>
                        <PropertySkFormButtons isBusy={this.isLoading()} />
                    </Form>
                )}
            </Formik>
        );
    }

    isLoading = () => {
        const values = [keys.regionId, keys.districtId, keys.municipalityId, keys.cadastreUnitId];
        for (let i = 0; i < values.length; ++i) {
            const key = values[i];
            if (!isNullOrUndefined(this.props.domain[key]) && this.props.domain[key].isRequesting === true)
                return true;
        }
        return false;
    }

    getParcelRegistries = () => [{ key: "", value: "", label: "" }, { key: "C", value: "C", label: "C" }, { key: "E", value: "E", label: "E" }];

    createValidationSchema = () => {
        const wrongInputMsg = this.props.translate("Search.Common.Validation.WrongInput");
        return YupObject().shape({
            [keys.regionId]: YupNumber().integer().required(wrongInputMsg),
            [keys.districtId]: YupNumber().integer().required(wrongInputMsg),
            [keys.municipalityId]: YupNumber().integer().required(wrongInputMsg),
            [keys.cadastreUnitId]: YupNumber().integer().required(wrongInputMsg),
            [keys.register]: YupString().trim().required(wrongInputMsg),
            [keys.parcelNo1]: YupNumber().integer().required(wrongInputMsg),
            [keys.parcelNo2]: YupNumber().integer(wrongInputMsg),
            [keys.parcelNo3]: YupNumber().integer(wrongInputMsg)
        });
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state, domain: state.domain }),
    dispatch => bindActionCreators(domainActions, dispatch),
)(PropertySkParcelSearchForm)));